import React, { useState, useContext } from 'react';
import FavoriteContext from '../context/FavoriteContext';
import logo from '../img/logo.png';

const Header = () => {
  const [showFavorites, setShowFavorites] = useState(false);

  const { favoritePokemons } = useContext(FavoriteContext);

  const showFavoritePokemons = (e) => {
    e.preventDefault();
    setShowFavorites(!showFavorites);
    return showFavorites;
  };

  return (
    <div className='container'>
      <div className='row pt-5 pb-5 d-flex justify-content-center'>
        <div className='row'>
          <div className='col-xs-8 d-flex justify-content-center'>
            <img src={logo} alt='logo' width='240' height='90' />
          </div>
          <div className='col-xs-2 ml-5 d-flex align-items-center justify-content-center'>
            <button onClick={showFavoritePokemons} className='favorites'>
              ❤ {favoritePokemons.length}
            </button>
            {showFavorites ? (
              <div className='pop-up-favorites'>
                <p>Favoritos:</p>
                {favoritePokemons.map((pokemon) => (
                  <p>❤️ {pokemon}</p>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
